import React, { useState } from "react";
import { Phone, HelpCircle, ChevronDown, ChevronUp } from "lucide-react";
import "./Support.css";

const faqs = [
  {
    q: "How can I mark an order as delivered?",
    a: "Go to your active orders list, open the order, and tap “Mark as Delivered.”"
  },
  {
    q: "My payment hasn’t been received, what should I do?",
    a: "Payments are processed within 24 hours. If still pending, contact support."
  },
  {
    q: "Customer address is incorrect — what should I do?",
    a: "Call the customer directly. If unresolved, report it to the support team immediately."
  },
  {
    q: "My app shows location error or GPS off?",
    a: "Ensure GPS and internet are enabled, and grant location permission in your phone settings."
  }
];

const Support = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="support-page">
      <h2 className="support-title">Support & Help Center</h2>

      {/* Contact Section */}
      <div className="support-card contact-section">
        <h3><Phone size={20} /> Contact Support</h3>
        <p>If you’re facing any issues with delivery, please contact our support team.</p>
        <div className="support-info">
          <p><strong>Call Support:</strong> +91 82769-69281</p>
          <p><strong>Available:</strong> 9:00 AM – 9:00 PM</p>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="support-card faq-section">
        <h3><HelpCircle size={20} /> Frequently Asked Questions</h3>
        <div className="faq-list">
          {faqs.map((item, idx) => {
            const open = activeIndex === idx;
            return (
              <div key={idx} className={`faq-item ${open ? "open" : ""}`}>
                <button
                  type="button"
                  className="faq-q"
                  onClick={() => toggle(idx)}
                  aria-expanded={open}
                >
                  <span className="q-text">{idx + 1}. {item.q}</span>
                  <span className="q-icon">{open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</span>
                </button>

                <div
                  className="faq-a-wrapper"
                  style={{
                    maxHeight: open ? "400px" : "0px",
                    transition: "max-height 300ms ease",
                    overflow: "hidden"
                  }}
                >
                  <div className="faq-a">
                    <p>{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Support;
